<template>
  <div class="container">
    <div class="title"><span>首页</span>>  <span>{{wz}}</span>> 正文</div>
    <div class="neir">
      <div class="l">
       <div class="top">
         <p class="tip">{{info.name}}</p>
         <p class="timeP">    时间：{{info.createTime}}  阅读：{{info.viewNum}}</p>
         <p v-html="info.description"></p>

         <!--<div class="sxp">-->
           <!--<p>上一篇：pet检查肺癌万无一失吗？ </p>-->
           <!--<p>下一篇：PET-CT能检查早期胰腺癌吗？</p>-->
         <!--</div>-->
       </div>
       <!--<div class="c">医生在线肿瘤频道温馨提醒：文章描述内容可能并不符合您的实际病情，建议您扫码咨询客服或免费咨询热线：010-118115888</div>-->
        <!--<div class="b">-->
          <!--<p class="tj">-->
            <!--<span>荐</span>-->
            <!--相关文章-->
          <!--</p>-->
          <!--<p>petct可以检查卵巢癌吗？</p>-->
          <!--<p class="neirP">妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。<span>[详情]</span></p>-->
          <!--<p>petct可以检查卵巢癌吗？</p>-->
          <!--<p class="neirP">妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。<span>[详情]</span></p>-->
          <!--<p>petct可以检查卵巢癌吗？</p>-->
          <!--<p class="neirP">妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。<span>[详情]</span></p>-->
          <!--<p>petct可以检查卵巢癌吗？</p>-->
          <!--<p class="neirP">妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。<span>[详情]</span></p>-->
          <!--<p>petct可以检查卵巢癌吗？</p>-->
          <!--<p class="neirP">妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。<span>[详情]</span></p>-->
          <!--<p>petct可以检查卵巢癌吗？</p>-->
          <!--<p class="neirP">妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。妇科肿瘤是女性常见的疾病，往往高发于50-60岁的的女性群体，其中宫颈癌、卵巢癌，发病率都在日益增高。<span>[详情]</span></p>-->
        <!--</div>-->
        <!--<div class="page">-->
          <!--<el-pagination-->
            <!--background-->
            <!--layout="prev, pager, next"-->
            <!--:total="1000">-->
          <!--</el-pagination>-->
        <!--</div>-->
      </div>
      <div class="r">
        <div class="t">
          <div class="lT">
            <ul class="list">
              <li class="active">好文推荐 <p></p></li>
            </ul>
          </div>
          <ul class="lB">
            <li v-for="item in pagelist2" :key="item.id" @click="goinfo(item.id)">
              <img :src="item.picUrl" alt="">
              <div>
                <h3>{{item.name}}</h3>
                <p>好评1720</p>
              </div>
            </li>
          </ul>
        </div>
        <!--<div class="b">-->
          <!--<p class="tip">阅读排行</p>-->
          <!--<ul>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
          <!--</ul>-->
        <!--</div>-->
        <!--<div class="bs">-->
          <!--<p>扫描下方二维码咨询在线客服</p>-->
          <!--<img src="../../assets/image/rwm1.png" alt="">-->
          <!--<p>微信扫一扫</p>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          wz: '预约指南',
          info: {
            name: '',
            createTime: '',
            viewNum: '',
            description: ''
          },
          pagelist2: []
        }
    },
    methods: {
      goinfo(id) {
        this.$router.push({
          path: `/yyznxq?id=${id}&type=zx`
        })
      }
    },

    mounted(){
      if (this.$route.query.type) {
        server.informationInfo(this.$route.query.id).then((res) => {
          this.info = res.data
        })
          this.wz = 'PETCT/MR资讯'
      } else {
        server.guideInfo(this.$route.query.id).then((res) => {
          this.info = res.data
        })
      }
      server.informationTj(1).then((res) => {
        this.pagelist2 = res.data
      })
      document.documentElement.scrollTop = 0;
    }

}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .neir{
      display: flex;
      .l{
        width: 1010px;
        .top{
          img{
            width: 551px;
            height: 320px;
            display: block;
            margin: 20px auto;
          }
          p{
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            margin-bottom: 20px;
          }
          .tip{
            font-size: 22px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #040000;
            text-align: center;
          }
          .sxp{
            display: flex;
            p:nth-child(2){
              margin-left: auto;
            }
          }
        }
        .c{
          width: 1026px;
          height: 47px;
          background: url("../../assets/image/672.png") no-repeat;
          background-size: cover;
          margin: 30px auto;
          line-height: 47px;
          box-sizing: border-box;
          padding: 0 20px;
          font-size: 16px;
          /*font-family: Adobe Heiti Std;*/;
          font-weight: normal;
          color: #FFFFFF;
        }
        .b{
          .tj{
            font-size: 23px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            margin-bottom: 10px;
            span{
              display: inline-block;
              font-size: 16px;
              /*font-family: Adobe Heiti Std;*/;
              font-weight: normal;
              color: #FFFFFF;
              width: 24px;
              height: 24px;
              background: #000000;
              text-align: center;
              line-height: 24px;
              vertical-align: middle;
            }
          }
          p{
            font-size: 18px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            span{
              color: rgba(23, 4, 204, 1);
            }
          }
          .neirP{
            margin-bottom: 20px;
          }
        }
        .page {
          padding: 30px;
          text-align: center;
        }
      }
      .r{
        width: calc(100% - 1030px);
        margin-left: 20px;
        .t{
          width: 344px;
          height: 587px;
          background: #FFFFFF;
          border: 2px solid #EAEBEB;
          border-radius: 5px;
          .lT{
            width: 100%;
            .list{
              margin-bottom: 10px;
              li{
                text-align: center;
                cursor: pointer;
                font-size: 19px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
                line-height: 33px;
                padding-top: 10px;
                border-bottom: 2px solid #EAEBEB;;
                p{
                  width: 97px;
                  height: 4px;
                  background: rgba(0, 180, 247, 0);
                  margin: 10px auto 0;
                }
              }
              li.active{
                p{
                  background: rgba(0, 180, 247, 1);
                }
              }
            }
          }
          .lB{
            width: 100%;
            padding: 0 20px;
            li{
              display: flex;
              margin-bottom: 20px;
              img{
                width: 103px;
                height: 72px;
              }
              div{
                padding: 4px 0;
                margin-left: 10px;
                width: calc(100% - 140px);
                h3{
                  font-size: 15px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #040000;
                  width: 100%;
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                p{
                  font-size: 14px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #E1E4EA;
                  margin-top: 15px;
                }
              }
            }
          }
        }
        .b{
          margin-left: 16px;
          margin-top: 36px;
          width: 323px;
          height: 581px;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          border-radius: 15px;
          padding: 10px;
          p{
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            border-bottom: 1px solid rgba(210, 214, 214, 1);
            line-height: 32px;
            padding: 5px 0;
          }
          ul{
            li{
              i{
                width: 6px;
                height: 6px;
                background: #000;
                border-radius: 50%;
                display: inline-block;
                vertical-align: middle;
                margin-right: 10px;
              }
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #000000;
              width: calc(100% - 20px);
              overflow:hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: 10px;
            }
          }
        }
        .bs{
          width: 323px;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          border-radius: 15px;
          margin-top: 30px;
          margin-left: 10px;
          padding: 20px;
          box-sizing: border-box;
          p:nth-child(1){
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            text-align: center;
            border-bottom: 1px solid rgba(210, 214, 214, 1);
            padding-bottom: 10px;
          }
          img{
            width: 150px;
            height: 150px;
            display: block;
            margin: 10px auto;
          }
          p:nth-child(3){
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            text-align: center;
          }
        }
      }
    }
  }
  @media (max-width: 750px) {
    .container {
      width: 100%;
      margin-top: 60px;
      .neir {
        display: block;
        padding: 15px;
        background-color: #FFFFFF;
        .l {
          width: 100%;
        }
        .r {
          display: none;
        }
      }
    }
  }
</style>
